import React,{useState} from "react";
import Kull from "./Kull";
import icons from "../helpers/icons";

const Barnebarn = (props) => {
    const barnebarn = props.barnebarn;
    const [expandAll,setExpandAll] = useState(false);
    const [collapseAll,setCollapseAll] = useState(false);

    const rows = barnebarn.map((kull) => (
        <Kull key={kull.kullId} kull={kull} expandAll={expandAll} setExpandAll={setExpandAll} collapseAll={collapseAll} setCollapseAll={setCollapseAll}/>
    ));

    function toggleCollapse(){
        setExpandAll(!expandAll);
        setCollapseAll(true)
    }
    return (
        <div>
            <div className="splitt-title-grey" onClick={()=>toggleCollapse()}>
                <div className={"flex-row"}>
                    <div style={{width: '100%'}}>
                        Børnebørn
                    </div>
                    <div><img src={icons.acdw} data-open={expandAll} alt=""/></div>
                </div>
            </div>

            {barnebarn.length > 0 && rows}
            {barnebarn.length === 0 &&
                <div>&nbsp;</div>
            }


        </div>
    );
};

export default Barnebarn;